<template>
  <footer class="footer">
    <div class="container footer__inner">
      <div class="footer__brand">
        <img
          src="/logo.svg"
          class="footer__logo"
          alt="ASH — Advanced System House"
          width="61"
          height="36"
        />
        <span class="footer__tag">AI-Driven Development &times; Backend Engineering — 栃木 / 宇都宮</span>
      </div>

      <div class="footer__side">
        <a href="#top" class="footer__top" @click="toTop">
          <span>Back to top</span>
          <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">
            <path d="M7 11V3M3 7l4-4 4 4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </a>
        <p class="footer__copy">&copy; 2026 Advanced System House Co.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  methods: {
    toTop(event) {
      event.preventDefault()
      window.scrollTo({ top: 0, behavior: 'smooth' })
      history.replaceState(null, '', location.pathname + location.search)
    },
  },
}
</script>

<style scoped lang="scss">
.footer {
  background: var(--dark);
  color: var(--on-dark);
  padding-block: clamp(44px, 5vw, 64px);
}

.footer__inner {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 28px;
  flex-wrap: wrap;
}

.footer__brand {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.footer__logo {
  display: block;
  height: 36px;
  width: auto;
  /* Logo art is dark brown/olive; render it light for the dark footer. */
  filter: brightness(0) invert(1);
  opacity: 0.92;
}

.footer__tag {
  font-family: var(--font-mono);
  font-size: 0.72rem;
  letter-spacing: 0.06em;
  color: var(--on-dark-muted);
}

.footer__side {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 14px;
}

.footer__top {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-mono);
  font-size: 0.74rem;
  letter-spacing: 0.08em;
  color: var(--on-dark-soft);
  transition: color 0.25s var(--ease);
}

.footer__top:hover {
  color: #fff;
}

.footer__top svg {
  transition: transform 0.3s var(--ease);
}

.footer__top:hover svg {
  transform: translateY(-3px);
}

.footer__copy {
  font-size: 0.8rem;
  color: var(--on-dark-muted);
}

@media (max-width: 620px) {
  .footer__inner {
    flex-direction: column;
    align-items: flex-start;
  }
  .footer__side {
    align-items: flex-start;
  }
}
</style>
